import React from "react";
import { Box, Tooltip, Icon, IconButton } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import CallIcon from "@mui/icons-material/Call";
import { Badge } from "@material-ui/core";
import MDTypography from "components/MDTypography";

export default function PhoneHeader({
  connectionState,
  callListCount,
  onOpenCallList,
  pttStatus,
  callType,
  callActive,
  callStreamId,
  darkMode,
  compactMode = false,
}) {
  const isConnected = connectionState === "connected";
  const isConnecting = connectionState === "connecting";
  const statusLabel = isConnected
    ? "Connected"
    : isConnecting
      ? "Connecting"
      : connectionState === "disconnected"
        ? "Disconnected"
        : "";

  const statusColor = isConnected
    ? "rgba(35, 238, 24, 0.95)"
    : isConnecting
      ? "#f7b500"
      : connectionState === "disconnected"
        ? "red"
        : "gray";

  const title = callType.isSOS
    ? `🚨 SOS Call ${callStreamId}`
    : callType.isAmbient
      ? `🚨 Ambient Mode ${callStreamId}`
      : callStreamId || "";

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: compactMode ? "8px 12px" : "12px 16px",
          background: darkMode
            ? "linear-gradient(90deg, rgba(15, 52, 96, 0.6) 0%, rgba(22, 33, 62, 0.6) 100%)"
            : "linear-gradient(90deg, rgba(33, 150, 243, 0.05) 0%, rgba(25, 118, 210, 0.05) 100%)",
          borderBottom: darkMode
            ? "1px solid rgba(66, 165, 245, 0.2)"
            : "1px solid rgba(33, 150, 243, 0.1)",
          borderRadius: "0 0 8px 8px",
          backdropFilter: "blur(10px)",
          transition: "all 0.3s ease",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <FiberManualRecordIcon
            sx={{
              color: statusColor,
              fontSize: compactMode ? 12 : 16,
            //   animation: isConnected ? "none" : isReconnecting ? "pulse 1s infinite" : "blink 1s infinite",
              "@keyframes pulse": {
                "0%": {
                  opacity: 0.6,
                  transform: "scale(1)",
                },
                "50%": {
                  opacity: 1,
                  transform: "scale(1.1)",
                },
                "100%": {
                  opacity: 0.6,
                  transform: "scale(1)",
                },
              },
              "@keyframes blink": {
                "0%, 50%, 100%": {
                  opacity: 1,
                },
                "25%, 75%": {
                  opacity: 0.4,
                },
              },
            }}
          />
          <Icon
            sx={{
              color: isConnected
                ? "rgba(35, 238, 24, 0.8)"
                : darkMode
                  ? "rgba(144, 202, 249, 0.8)"
                  : "rgba(21, 101, 192, 0.8)",
              fontSize: compactMode ? 14 : 16,
            }}
          >
            lock_outline_icon
          </Icon>

          {statusLabel && (
            <MDTypography
              variant="caption"
              sx={{
                fontWeight: 700,
                color: darkMode ? "#90caf9" : "#1565c0",
                letterSpacing: "0.2px",
              }}
            >
              {statusLabel}
            </MDTypography>
          )}
        </Box>

        {/* {callListCount > 0 && (
          <Tooltip title="Show Call List" arrow>
            <Badge
              badgeContent={callListCount}
              color="error"
              anchorOrigin={{ vertical: "top", horizontal: "left" }}
              sx={{
                "& .MuiBadge-badge": {
                  backgroundColor: "#ff4444",
                  color: "#ffffff",
                  boxShadow: `0 0 0 2px ${darkMode ? "#1a1a2e" : "white"}, 0 0 0 4px #ff4444`,
                  fontWeight: 800,
                  fontSize: "11px",
                  animation: "pulse 2s infinite",
                  "@keyframes pulse": {
                    "0%": {
                      boxShadow: `0 0 0 2px ${darkMode ? "#1a1a2e" : "white"}, 0 0 0 4px #ff4444`,
                    },
                    "50%": {
                      boxShadow: `0 0 0 2px ${darkMode ? "#1a1a2e" : "white"}, 0 0 0 8px rgba(255, 68, 68, 0.6)`,
                    },
                    "100%": {
                      boxShadow: `0 0 0 2px ${darkMode ? "#1a1a2e" : "white"}, 0 0 0 4px #ff4444`,
                    },
                  },
                },
              }}
            >
              <IconButton
                onClick={onOpenCallList}
                sx={{
                  position: "relative",
                  width: 28,
                  height: 28,
                  minWidth: 28,
                  background:
                    "linear-gradient(135deg, #2196F3 0%, #1976D2 100%)",
                  color: "white",
                  borderRadius: "50%",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  boxShadow: "0 4px 20px rgba(33, 150, 243, 0.4)",
                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #42a5f5 0%, #1e88e5 100%)",
                    boxShadow: "0 8px 30px rgba(33, 150, 243, 0.6)",
                    transform: "translateY(-4px) scale(1.12)",
                  },
                  "&:active": {
                    transform: "translateY(-1px) scale(1.05)",
                  },
                }}
              >
                <CallIcon
                  sx={{
                    fontSize: 16,
                    animation: "ring 2s infinite",
                    "@keyframes ring": {
                      "0%, 100%": {
                        transform: "rotate(0deg)",
                      },
                      "10%, 20%": {
                        transform: "rotate(-10deg)",
                      },
                      "30%, 50%, 70%, 90%": {
                        transform: "rotate(10deg)",
                      },
                      "40%, 60%, 80%": {
                        transform: "rotate(-10deg)",
                      },
                    },
                  }}
                />
              </IconButton>
            </Badge>
          </Tooltip>
        )} */}

        <MDTypography
          variant={compactMode ? "caption" : "body2"}
          sx={{
            color: callActive ? "#ffd700" : darkMode ? "#90caf9" : "#1565c0",
            fontWeight: 600,
            textShadow: darkMode ? "0 2px 4px rgba(0,0,0,0.5)" : "none",
          }}
        >
          {callActive ? pttStatus : "No Call Active"}
        </MDTypography>
      </Box>

      <MDTypography
        variant={compactMode ? "body2" : "h6"}
        sx={{
          color: darkMode ? "#90caf9" : "#1565c0",
          textAlign: "center",
          width: "100%",
          mb: compactMode ? 0.5 : 1,
          fontWeight: 600,
          textShadow: darkMode ? "0 2px 4px rgba(0,0,0,0.5)" : "none",
        }}
      >
        {title}
      </MDTypography>
    </>
  );
}
